module.exports = __webpack_public_path__ + "img/exercise_notes.9bf98a00.png";